import DropdownEmpty from './DropdownEmpty';
import React, { forwardRef, useState } from 'react';
import ReactSelect, { components } from 'react-select';

// react-select remembers the last pointer-focused option after the pointer leaves.
// Only keyboard navigation should paint that retained focus; pointer uses :hover.
function Option(props) {
  const Component = props.selectProps.originalOption || components.Option;
  return <Component {...props} isFocused={props.isFocused && props.selectProps.keyboardOptionFocus} />;
}
function MenuList(props) {
  const Component = props.selectProps.originalMenuList || components.MenuList;
  const innerRef = (node) => {
    if (node && props.selectProps.classNamePrefix === 'modal-select') {
      node.style.setProperty('padding', '0', 'important');
      node.style.setProperty('min-height', '0', 'important');
      node.style.setProperty('height', 'auto', 'important');
    }
    const ref = props.innerRef;
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
  };
  return <Component {...props} innerRef={innerRef} />;
}
function Menu(props) {
  const Component = props.selectProps.originalMenu || components.Menu;
  return <Component {...props} innerProps={{ ...props.innerProps,
    onPointerMoveCapture: event => {
      props.selectProps.clearKeyboardOptionFocus();
      props.innerProps?.onPointerMoveCapture?.(event);
    },
  }} />;
}
const Select = forwardRef(function Select(props, ref) {
  const [keyboardOptionFocus, setKeyboardOptionFocus] = useState(false);
  return <ReactSelect menuPlacement="auto" menuShouldScrollIntoView={false} {...props} ref={ref}
    styles={{
      ...props.styles,
      dropdownIndicator: (base, state) => ({
        ...(props.styles?.dropdownIndicator ? props.styles.dropdownIndicator(base, state) : base),
        color: 'var(--content-secondary, #b8bcc8) !important',
        '&:hover': { color: 'var(--content-secondary, #b8bcc8) !important' },
      }),
      control: (base, state) => {
        const style = props.styles?.control ? props.styles.control(base, state) : base;
        const highlight = 'var(--field-highlight, #596176) !important';
        return {
          ...style,
          ...((state.isFocused || state.menuIsOpen) && !state.isDisabled ? { borderColor: highlight, boxShadow: 'none' } : {}),
          '&:hover': {
            ...style['&:hover'],
            ...(!state.isDisabled ? { borderColor: highlight, boxShadow: 'none' } : {}),
          },
        };
      },
    }}
    keyboardOptionFocus={keyboardOptionFocus}
    clearKeyboardOptionFocus={() => setKeyboardOptionFocus(false)}
    originalOption={props.components?.Option}
    originalMenu={props.components?.Menu}
    originalMenuList={props.components?.MenuList}
    components={{ ...props.components, NoOptionsMessage: props.components?.NoOptionsMessage || (() => <DropdownEmpty />), Option, Menu, MenuList }}
    onKeyDown={event => {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'].includes(event.key)) setKeyboardOptionFocus(true);
      props.onKeyDown?.(event);
    }}
    onMenuClose={() => { setKeyboardOptionFocus(false); props.onMenuClose?.(); }}
  />;
});
export default Select;
